module.exports = __webpack_public_path__ + "img/shib-logo.631b9da6.svg";